import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ViewStateService } from './view-state.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const viewState = inject(ViewStateService);

  if (viewState.CurrentViewState.isUserLoggedIn) {
    return true;
  }

  return router.createUrlTree(['auth']);
};